<template>
    <table>
        <thead class="thead">
        <tr>
            <th v-for="titleHeader in $tm('page.tariffs.table')" :key="titleHeader">
                <span class="headed_text">{{ titleHeader }}</span>
            </th>
        </tr>
        </thead>
        <tbody class="compact-table" ref="scrollComponent">
        <tr v-for="(number, index) in rowData" :key="number.api_key">
            <template v-if="number.number !== '0'">
                <td class="number">
                    <div
                        class="number-container"
                        :class="{ 'with-tag': number.tags?.[0] }"
                    >
                        <img
                            :src="require(`@/assets/icons/${msg.value || number.source}.svg`).default"
                            alt="messenger-icon"
                        />
                        <div class="number_with_tags">
                            <span v-text="number.number"/>
                            <BaseTag :tag="number.tags[0]" typeClass="table"/>
                        </div>
                    </div>
                </td>
                <td class="integration">
                    <ul v-if="!!number.integrations?.length" class="crm_list">
                        <li
                            v-for="(nextEl, nextIndex) in number.integrations"
                            :key="nextIndex"
                            class="crm_item"
                        >
                            {{ nextEl }}
                        </li>
                    </ul>
                    <span v-else>-</span>
                </td>
                <td class="paid_to">
                    <span>{{ number.tariff_end_date || "-" }}</span>
                </td>
                <td v-show="!!msg.value || number.source" class="custom-checkbox">
                    <input
                        type="checkbox"
                        :id="`сheckbox${toUpperCaseFirstLetter(msg.value || number.source)}${index}`"
                        :checked="checkIfSelected(number.number, msg.value)"
                        @change="$emit('toggleSelectionHandler', number, msg.value || number.source)"
                    />
                    <label
                        :for="`сheckbox${toUpperCaseFirstLetter(msg.value || number.source)}${index}`"
                    ></label>
                </td>
            </template>
        </tr>
        <tr>
            <td style="border-bottom: none" colspan="4">
                <slot name="information_column"/>
            </td>
        </tr>
        </tbody>
    </table>
</template>

<script setup>
import {ref} from "vue";
import BaseTag from "@/components/ui/BaseTag.vue";
import {toUpperCaseFirstLetter} from "@/helpers/textTransform";
import {useInfiniteScroll} from "@vueuse/core";

const props = defineProps({
    rowData: {
        type: Array,
        default: () => [],
    },
    msg: {
        type: Object,
        default: () => ({}),
    },
    checkIfSelected: {
        type: Function,
        default: () => false,
    }
});

const scrollComponent = ref(null);

const emit = defineEmits(["loadMore", "toggleSelectionHandler"]);

const {isLoading} = useInfiniteScroll(
    scrollComponent,
    () => {
        if (!props.rowData?.length || isLoading.value) return;
        emit("loadMore");
    },
    {
        distance: 50,
        interval: 300,
    }
);
</script>

<style lang="scss" scoped>
@use "@/styles/table.scss";

.rotate {
    transform: rotate(180deg);
}

.arrow-down {
    transition: transform 0.5s ease;
}

.reverced {
    transform: rotate(180deg);
    transition: transform 0.5s ease;
}

.custom-checkbox input[type="checkbox"] {
    display: none;
}

.custom-checkbox label {
    display: inline-block;
    width: 25px;
    height: 25px;
    border: 1px solid lightgrey;
    cursor: pointer;
    position: relative;
}

.custom-checkbox label::after {
    content: "";
    background-image: url("../../assets/tariffs/check.png");
    background-size: contain;
    width: 12px;
    height: 12px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: none;
}

.custom-checkbox input[type="checkbox"]:checked + label::after {
    display: block;
}

th,
td {
    // width: fit-content;
    text-align: center;

    &:first-child,
    &:last-child {
        min-width: 140px;
        // width: fit-content;
    }
}

.th-container {
    display: flex;
    align-items: baseline;
    justify-content: center;
    gap: 5px;
}

.crm_list {
    display: flex;
    column-gap: 5px;
    flex-wrap: wrap;
    justify-content: center;
    text-transform: uppercase;
    overflow: hidden;
    height: auto;
    line-height: 1.2rem;
}

.crm_item:not(:last-child):after {
    content: ", ";
}
</style>
